import * as moment from 'moment';

export const parseDate = timestamp => {
  if (timestamp === null) {
    return null;
  }

  const months = {
    1: 'ledna',
    2: 'února',
    3: 'března',
    4: 'dubna',
    5: 'května',
    6: 'června',
    7: 'července',
    8: 'srpna',
    9: 'září',
    10: 'října',
    11: 'listopadu',
    12: 'prosince'
  };

  moment.locale('cs');
  const parsed = moment.unix(timestamp);
  const month = months[parsed.format('M')];

  return `${parsed.format(`D`)}. ${month}`;
};

export const getSchoolYear = () => {
  if (moment().get('month') < 8) {
    // January - August
    return `${moment().get('year') - 1}/${moment().get('year')}`;
  } else {
    return `${moment().get('year')}/${moment().get('year') + 1}`;
  }
};

export const rerouteDestinations = {
  student: 'detail',
  teacher: 'overview',
  admin: 'dashboard'
};
